// extracted by mini-css-extract-plugin
export var measureBox = "_51-0";